import { render, staticRenderFns } from "./AdditionalDescriptionEdit.vue?vue&type=template&id=5b85ca98"
import script from "./AdditionalDescriptionEdit.vue?vue&type=script&lang=js"
export * from "./AdditionalDescriptionEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports